<template>
  <div class="mobile-policy-content">
    <div class="header">
      <div class="background-wrapper"></div>
    </div>
    <div v-html="policyInfo.i18nContent" class="body"></div>
    <div class="footer">
      <span>Copyright © 2012~{{ new Date()|formatDateTime('YYYY') }} AJINGA Inc.  All rights reserved.</span>
      <div class="background-wrapper"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    policyInfo: {
      type: Object,
      required: true
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  }
}

</script>

<style lang="scss" scoped>
.mobile-policy-content {
  min-height: 100vh;

  .header {
    position: relative;

    .background-wrapper {
      width: 100%;
      height: 330px;
      background: url($baseDomain + 'static/images_en/bgTop.jpg?t=1') repeat-x;
      position: absolute;
      top: 0;
      z-index: -1;
    }
  }

  .body {
    margin: auto;
    padding: 15px;
  }

  .footer {
    padding-bottom: 10px;
    text-align: center;
    position: relative;

    .background-wrapper {
      width: 100%;
      height: 320px;
      background: url($baseDomain + 'static/images_en/bgBottom.jpg?t=1') repeat-x;
      position: absolute;
      bottom: 0;
      z-index: -1;
    }
  }
}
</style>
